import React from 'react'
import { useQuery } from '@apollo/client'
import { i18n } from '@fs/zion-locale'
import queries from '../views/CameraOperatorProjectsDashboard/queries'

export default function useLanguageFormat() {
  const { data: standardsLanguages } = useQuery(queries.standardsLanguages, {
    variables: { langOverride: i18n.language },
  })

  const getLanguageFromCode = React.useCallback(
    (code) => {
      if (!standardsLanguages) return null
      return standardsLanguages.standardsLanguages.find((lang) => lang.code === code)?.language || ''
    },
    [standardsLanguages]
  )

  return { getLanguageFromCode }
}
